/**
 * Stane — first-touch UTM capture
 *
 * Stores UTM/click-id parameters from the URL in a 30-day cookie on the very
 * first visit (first-touch attribution). On subsequent visits the cookie is
 * NOT overwritten, so the original campaign that brought the visitor stays
 * attached even if they later return via direct or another channel.
 *
 * Exposes window.staneGetFirstTouch() for the B2B form-handler to read.
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'stane_first_touch';
  var COOKIE_TTL_DAYS = 30;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var CLICK_IDS = ['gclid', 'fbclid'];

  function getCookie(name) {
    try {
      var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    } catch (e) {
      // Sandboxed iframes / restricted contexts: cookie access throws.
      return null;
    }
  }

  function setCookie(name, value, days) {
    try {
      var expires = new Date(Date.now() + days * 86400000).toUTCString();
      document.cookie = name + '=' + encodeURIComponent(value) +
        '; expires=' + expires + '; path=/; SameSite=Lax; Secure';
    } catch (e) {
      // Sandboxed iframes / restricted contexts: silently no-op.
    }
  }

  function getUrlParam(key) {
    try {
      return new URLSearchParams(window.location.search).get(key) || '';
    } catch (e) {
      return '';
    }
  }

  function readExisting() {
    try {
      var raw = getCookie(COOKIE_NAME);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null; // corrupt cookie → treat as missing
    }
  }

  // Merge-policy (gewijzigd 2026-05-05): first-touch blijft heilig voor velden
  // die al ingevuld zijn, maar lege velden worden aangevuld vanuit nieuwere
  // URL-parameters. Voorbeeld scenario: bezoeker arriveert eerst met partial
  // UTMs (alleen source+medium gezet door ad-platform redirect), keert later
  // terug via volledige URL met utm_term/utm_content. Zonder merge zou de
  // form-submission utm_term/utm_content mist.
  //
  // Merge-regels per veld:
  //   - utm_source/medium/campaign : first-touch wint (existing > URL)
  //   - utm_term/utm_content       : aanvullen indien leeg in cookie
  //   - gclid/fbclid               : aanvullen indien leeg in cookie
  //   - landing_page               : NOOIT overschrijven (allereerste bezoek)
  //   - referrer                   : NOOIT overschrijven
  //   - first_touch_date           : NOOIT overschrijven
  function captureFirstTouch() {
    var existing = readExisting() || {};
    var allKeys = UTM_KEYS.concat(CLICK_IDS); // 7 velden totaal
    var merged = {};
    var changed = false;

    allKeys.forEach(function (key) {
      var existingVal = existing[key] || '';
      var urlVal = getUrlParam(key);
      if (existingVal) {
        // First-touch wint — ongeacht of URL nu een andere waarde heeft.
        // Geldt voor source/medium/campaign EN voor term/content/gclid/fbclid
        // (eerst gevuld blijft gevuld).
        merged[key] = existingVal;
      } else if (urlVal) {
        // Veld was leeg in cookie en URL heeft een waarde → aanvullen.
        merged[key] = urlVal;
        changed = true;
      } else {
        merged[key] = '';
      }
    });

    // Landing-page / referrer / first_touch_date: only set on very first
    // capture, never overwrite. Mist in oude cookies (pre-merge format)
    // wordt dit gevuld bij het eerstvolgende bezoek.
    merged.landing_page = existing.landing_page || window.location.href;
    merged.referrer = (existing.referrer !== undefined) ? existing.referrer : (document.referrer || '');
    merged.first_touch_date = existing.first_touch_date || new Date().toISOString();

    var isFirstWrite = Object.keys(existing).length === 0;
    if (changed || isFirstWrite) {
      setCookie(COOKIE_NAME, JSON.stringify(merged), COOKIE_TTL_DAYS);
    }
  }

  window.staneGetFirstTouch = function () {
    return readExisting();
  };

  captureFirstTouch();
})();
